import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Translate from 'components/Translate';
import Box from 'components/UI/Box/Box';
import Button from 'components/UI/Button';
import { getPoints } from 'modules/loyaltyPoints/actions';
import useLiterals from 'utils/hooks/useLiterals';
import { ReactComponent as MedalRibbonsStarIcon } from 'assets/icons/medal-ribbons-star.svg';
import { ReactComponent as EyeIcon } from 'assets/icons/eye.svg';
import { formatNumber } from 'utils/formatCurrency';
import InlineError from 'components/UI/InlineError';
import { ROUTE_PATH } from 'routes';

const UserLoyaltyPoints = ({ home = true, isPreview = false }) => {
  const { user } = useSelector((state) => state.session);
  const literals = useLiterals('loyaltyPoints');
  const { data: points, error } = useSelector((state) => state.loyaltyPoints.points);
  const dispatch = useDispatch();

  useEffect(() => {
    if (home && user?.id) {
      dispatch(getPoints());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  if (!user?.id && !isPreview) {
    return null;
  }

  return (
    <div>
      {home && <h2 className='mb-4'>{literals.yourLoyaltyPoints}</h2>}
      <Box className='card-loyalty-points mb-4' padding='sm'>
        {error && <InlineError error={literals.errorLoadPoints} className='mb-6' />}
        <div className='flex gap-4 mb-4'>
          <MedalRibbonsStarIcon width={48} />
          <div>
            <p className='mb-2'>{literals.unusedPoints}</p>
            <Translate className='font-bold text-lg mb-0' literal={literals.numberPoints} vars={{ points: formatNumber(points?.available ?? '-') }} />
          </div>
        </div>
        {home && points?.welcomeBonus > 0 && (
          <Translate
            className='mb-4'
            literal={literals.welcomeBonus}
            vars={{ points: formatNumber(points.welcomeBonus) }}
          />
        )}
        <Translate className={`text-primary font-semibold ${home ? 'mb-6' : 'mb-0'}`} literal={literals.clientNumberNumber} vars={{ number: user?.clientId || '-' }} />
        {home && (
          <div className='flex gap-4'>
            <Button
              text={literals.couponHistory}
              size='sm'
              to={ROUTE_PATH.LOYALTY_POINTS_COUPONS}
            />
            <Button
              size='sm'
              to={ROUTE_PATH.LOYALTY_POINTS_PROMOTIONS}
              className='flex items-center gap-2 justify-center'
            >
              <EyeIcon width={16} />
              {literals.promotions}
            </Button>
          </div>
        )}
      </Box>
    </div>
  );
};

UserLoyaltyPoints.propTypes = {
  home: PropTypes.bool,
  isPreview: PropTypes.bool,
};

export default UserLoyaltyPoints;
